import { ImgHTMLAttributes } from "react";

interface SmartImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  /**
   * If true, look for a sibling .webp at the same path and serve it via <picture>.
   * Defaults to true for /images/* paths.
   */
  webp?: boolean;
}

/**
 * Lightweight responsive image: emits a <picture> with a WebP source
 * and the original as fallback. Defaults to lazy + async decoding.
 */
const SmartImage = ({ src, alt, webp, className, ...rest }: SmartImageProps) => {
  const shouldWebp = webp ?? /\.(jpe?g|png)$/i.test(src);
  const webpSrc = shouldWebp ? src.replace(/\.(jpe?g|png)$/i, ".webp") : null;

  return (
    <picture>
      {webpSrc && <source srcSet={webpSrc} type="image/webp" />}
      <img
        src={src}
        alt={alt}
        loading={rest.loading ?? "lazy"}
        decoding={rest.decoding ?? "async"}
        className={className}
        {...rest}
      />
    </picture>
  );
};

export default SmartImage;
